import avatar from "@assets/img/defaultAvatar.png";

import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";

import Skeleton from "react-loading-skeleton";
import { Card } from "@components/cards/card";
import { ModalInfo } from "@components/modals/modal-info";
import { useModalContext } from "@hooks/contexts/modal-context";
import { IModalInfoDTO } from "@hooks/dtos/IModalInfoDTO";
import { formatName } from "@hooks/functions/formatName";
import { Masks } from "@hooks/functions/Masks/Masks";
import { Input } from "@components/forms/input";

interface IModalInfoList {
  [key: string]: {
    header: string;
    title: string;
    text: string;
  };
}

interface IsAccountLoading {
  info: boolean;
}

const masks = new Masks();
export function Account() {
  const { customer } = ZuAuthStore();

  const modalInfoList: IModalInfoList = {
    balance: {
      header: "Saldo Disponível",
      title: "Resumo Financeiro",
      text: "Imprime o valor disponível para saque e demais transações financeiras na plataforma.",
    },
  };

  const location = useLocation();
  const { changeHash } = useModalContext();

  const [modalInfo, setModalInfo] = useState<IModalInfoDTO>({
    header: ``,
    title: ``,
    text: ``,
  });

  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [isLoading, setIsLoading] = useState<IsAccountLoading>({
    info: false,
  });

  useEffect(() => {
  }, []);

  return (
    <>
      {/* Account Summary */}
      <div className="row">
        {/* Perfil Summary */}
        <div className="col-md-4">
          <Card className="position-relative">
            <div className="card-header">
              <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                  <div>Informações do Perfil</div>
                  <div>
                    <span
                      className={`rounded-circle d-inline-block me-2 bg-success`}
                      style={{ width: 15, height: 15 }}
                      title={`Ativo`}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              {isLoading.info ? (
                <Skeleton count={1} />
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-3 d-flex flex-column justify-content-center align-items-center">
                        <div className="avatar avatar-xxl">
                          <img
                            src={
                              customer?.customer?.photos?.avatar?.url || avatar
                            }
                            alt=""
                            className="avatar-img rounded-circle"
                          />
                        </div>
                      </div>
                      <div className="col-md-9 d-flex flex-column">
                        <h5 className="fw-bold">
                          {formatName(
                            customer?.customer?.name
                              ? customer?.customer?.name
                              : ``
                          )}
                        </h5>
                        <span>
                          Gênero:{" "}
                          {"Indefinido"}
                        </span>
                        <span className="d-flex align-items-center">
                          E-mail Verificado:{" "}
                          <span
                            className={`rounded-circle d-inline-block ms-1 bg-${
                              customer?.customerInfo?.emailCheck === `y`
                                ? `success`
                                : `danger`
                            }`}
                            style={{ width: 13, height: 13 }}
                            title={
                              customer?.customerInfo?.emailCheck === `y`
                                ? `Verificado`
                                : `Pendente`
                            }
                          ></span>
                        </span>
                        <span>
                          Nascimento:{" "}
                          {customer?.customerInfo?.birth
                            ? dayjs(customer?.customerInfo?.birth).format(
                                "DD/MM/YYYY"
                              )
                            : "~"}
                        </span>
                        <span>
                          Cadastro:{" "}
                          {customer?.customer?.createdAt
                            ? dayjs(customer?.customer?.createdAt).format(
                                "DD/MM/YYYY [às] HH:MM:ss"
                              )
                            : "~"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>

        {/* Important Info */}
        <div className="col-md-8">
          <Card className="position-relative">
            <div className="card-header">
              <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                  <div>Outras Informações</div>
                </div>
              </div>
            </div>
            <div className="card-body">
              {isLoading.info ? (
                <Skeleton count={1} />
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    <Input
                      label="E-mail"
                      placeholder="Seu e-mail de cadastro"
                      animated
                      value={customer?.customer?.email || ""}
                    />
                  </div>
                  <div className="col-md-12">
                    <Input
                      label="Celular"
                      placeholder="Seu celular de cadastro"
                      animated
                      value={customer?.customerInfo?.cellPhone || ""}
                    />
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>

        {/* Location */}
        <div className="col-md-12">
          <Card className="position-relative">
            <div className="card-header">
              <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                  <div>Informações de Localidade</div>
                </div>
              </div>
            </div>
            <div className="card-body">
              {isLoading.info ? (
                <Skeleton count={1} />
              ) : (
                <>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        label="País"
                        placeholder="País"
                        animated
                        value={customer?.customerInfo?.countryData?.name || ""}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label="Estado"
                        placeholder="Estado"
                        animated
                        value={customer?.customerInfo?.stateData?.name || ""}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        label="Cidade"
                        placeholder="Cidade"
                        animated
                        value={customer?.customerInfo?.cityData?.name || ""}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label="Logradouro"
                        placeholder="Logradouro"
                        animated
                        value={customer?.customerInfo?.address || ""}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </Card>
        </div>
      </div>

      <ModalInfo
        header={modalInfo.header}
        title={modalInfo.title}
        text={modalInfo.text}
        isOpen={location?.hash === "#modalInfo"}
        onClose={() => {
          changeHash("");
        }}
      />
    </>
  );
}
